import { Flex, Icon, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import ArrowLeft from "@/assets/svg/pagination-left.svg";
import ArrowRight from "@/assets/svg/pagination-right.svg";
import { useActions } from "@/hooks/useActions";
import useCompaniesListRequest from "@/hooks/useCompaniesListRequest";
import useGetCurrentView from "@/hooks/useGetCurrentView";
import newListSelectors from "@/store/newLists/newLists.slectors";
import { formatMoney } from "@/utils/formatNumber";

import LimitMenu from "./LimitMenu";

const PaginationCompanies = () => {
  const { setListParams, setViewParams } = useActions();
  const listParams = useSelector(newListSelectors.getListParams());
  const { currentParams, currentView } = useGetCurrentView();
  const { getCompanies } = useCompaniesListRequest();

  const isNotLimitCompanies = listParams?.total < currentParams?.limit;
  const isEnd = listParams?.page * currentParams?.limit;
  const isEndPagePosition = listParams?.total < isEnd;
  const endPagePosition = isNotLimitCompanies
    ? listParams?.total
    : isEndPagePosition
    ? listParams.total
    : isEnd;
  const startPagePosition = isNotLimitCompanies
    ? 1
    : isEnd - currentParams?.limit + 1;

  const isDisablePrev = listParams?.page < 2;
  const isDisableNext =
    listParams?.page === listParams?.pages || listParams?.pages === 1;

  const onGetCompaniesHandler = async ({ page, limit }) => {
    getCompanies({
      params: {
        ...currentParams,
        orderBy: currentParams?.orderBy?.value,
        page,
        limit: limit || currentParams?.limit,
      },
    });
  };

  const onSelectLimitHandler = (limit, onClose) => {
    onGetCompaniesHandler({ limit }).then(() => {
      setViewParams({ key: currentView?.id, params: { limit } });
      onClose();
    });
  };

  const onPrevPageHandler = () => {
    if (isDisablePrev) return;
    const page = listParams?.page - 1;
    onGetCompaniesHandler({ page }).then(() => {
      setListParams({
        page,
      });
    });
  };

  const onNextPageHandler = () => {
    if (isDisableNext) return;
    const page = listParams?.page + 1;
    onGetCompaniesHandler({ page }).then(() => {
      setListParams({
        page,
      });
    });
  };

  return (
    <Flex
      w={"100%"}
      align={"center"}
      justify={"end"}
      my={"20px"}
      fontSize={"14px"}
      fontWeight={"400"}
      lineHeight={"1.35"}
      letterSpacing={"2%"}
      color={"grey"}
      columnGap={"12px"}
      px={"20px"}
    >
      <Flex align={"center"} columnGap={"8px"}>
        <Text>Rows per page:</Text>
        <LimitMenu
          selectedLimit={currentParams?.limit}
          onSelectLimitHandler={onSelectLimitHandler}
        />
      </Flex>
      <Text display={{ base: "none", smx: "block" }}>
        {startPagePosition}-{endPagePosition} of{" "}
        {formatMoney(listParams?.total)} Companies
      </Text>
      <Flex align={"center"} columnGap={"8px"}>
        <Icon
          as={ArrowLeft}
          w={"24px"}
          h={"24px"}
          borderWidth={"1px"}
          borderRadius={"4px"}
          p={"4px"}
          _hover={{ bg: isDisablePrev ? "white" : "lightBlue2" }}
          cursor={isDisablePrev ? "auto" : "pointer"}
          onClick={onPrevPageHandler}
        />
        <Text display={{ base: "block", smx: "none" }} mt={"2px"}>
          {listParams?.page}
        </Text>

        <Icon
          as={ArrowRight}
          w={"24px"}
          h={"24px"}
          borderWidth={"1px"}
          borderRadius={"4px"}
          p={"4px"}
          _hover={{ bg: isDisableNext ? "white" : "lightBlue2" }}
          cursor={isDisableNext ? "auto" : "pointer"}
          onClick={onNextPageHandler}
        />
      </Flex>
    </Flex>
  );
};

export default PaginationCompanies;
